module.exports = __webpack_public_path__ + "static/media/add.e0e808bd.svg";